import React from 'react';
import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import DetailView from './DetailView';
import {historyMediaStore} from "../../store/MediaStore";
import HistoryView from "./HistoryView";
import CommonHelper from "../../helper/CommonHelper";
import qs from "qs";

const store = historyMediaStore;

@observer
class HistoryViewFrame extends React.Component {

    componentDidMount() {
        let {location} = this.props;
        store.searchCondition.replace(CommonHelper.objectToMap(qs.parse(this.props.location.search, { ignoreQueryPrefix: true })));
        store.debounceRefresh()
    }


    componentWillUnmount() {
        store.clear()
    }


    render() {
        return (
            <Switch>
                <Route path="/main/history/:folderId/:fileId" component={DetailView}/>
                <Route path="/main/history" component={HistoryView}/>
            </Switch>
        );

    }
}

export default HistoryViewFrame;
